import Api from "./Api";

const Clients = () => {
    return Api().get("/clients")
}

const Client = (id) => {
    return Api().get(`/clients/${id}`)
}

const AddClient = (data) => {
    return Api().post("/clients", data)
}

const EditClient = (id, data) => {
    return Api().put(`/clients/${id}`, data)
}

const RemoveClient = (id) => {
    return Api().delete(`/clients/${id}`)
}

export { Clients, Client, AddClient, EditClient, RemoveClient }